// Open Haunt (/haunt): the zone itself lives in src/zones/open-haunt/ (wave 12). The beginner guide (/haunt/guide)
// stays held until it can be followed end to end (launch-copy.ts, "guide-public").

import { clear, h, link } from "../dom.ts";
import { GUIDE } from "../launch-copy.ts";
import { setTitle } from "../router.ts";
import { openHauntPage } from "../zones/open-haunt/page.ts";
import { block, ctxWith, passes, type Ctx } from "./developers.ts";

/** /haunt: the Open Haunt zone (src/zones/open-haunt/). */
export function hauntPage(): Promise<HTMLElement> {
  return openHauntPage();
}

/** /haunt/guide: the beginner guide, once it can be followed end to end; until then a pointer back. */
export function hauntGuidePage(): HTMLElement {
  setTitle("Make your first haunt");
  const c: Ctx = ctxWith({});
  if (!passes("[[?guide-public|yes]]", c))
    return h(
      "div",
      { class: "empty" },
      h("h1", null, "The beginner guide is on its way"),
      h("p", { class: "dim" }, "It goes up here as soon as the tools it uses are public."),
      link("/haunt", { class: "btn" }, "Back to Open Haunt"),
    );
  const host = h("article", { class: "copy-page guide" });
  clear(host, GUIDE.map((b) => block(b, c)));
  return host;
}
